import { FileDownloaderService } from './../../shared/components/file-downloader/file-downloader.service'
import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { ArquivoModel } from '@shared/models/backend'

@Component({
  selector: 'app-list-files',
  templateUrl: './list-files.component.html',
  styleUrls: ['./list-files.component.scss'],
})
export class ListFilesComponent implements OnInit {
  title: string
  files: ArquivoModel[] = []

  constructor(@Inject(MAT_DIALOG_DATA) data: any, private fileDownloaderService: FileDownloaderService) {
    this.title = data.title || 'Arquivos'
    this.files = data.files || []
  }

  ngOnInit(): void {}

  download(arquivo: ArquivoModel) {
    this.fileDownloaderService.download(arquivo)
  }
}
